module.exports = __webpack_public_path__ + "static/media/team-amy.23af42ae.jpg";